import AuthLayout from "../components/auth/AuthLayout";
import EmancipatedMinorRegistration from "../components/auth/EmancipatedMinors";

const MinorsRegistration = () => {
  return (
    <AuthLayout>
      <EmancipatedMinorRegistration />
    </AuthLayout>
  );
};

export default MinorsRegistration;
